import React, { useState } from "react";
import "../../styles/updatepassword.css";
import axios from "axios";
import { useDispatch } from "react-redux";
import { loginReducer } from "../../Redux/store";
import { AccessTockenReducer } from "../../Redux/store";
import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { InputAdornment, IconButton } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

function UpdatePassword() {
  const dispatch = useDispatch();
  const tocken = useSelector((state) => state.AccessTocken.accessTocken);
  const id = useSelector((state) => state.Login.loginUser_id);

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [renterPassword, setReEnterPassword] = useState("");
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showReenterPassword, setShowReenterPassword] = useState(false);
  // const [id, setId] = useState(null);

  var passwordValid = new RegExp(
    // /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#/\$%\^&\*])(?=.{8,20})/
    /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#/$%^&*])(?=.{8,20})/
  );

  let options = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${tocken}`,
    },
  };

  const newPassword_data = {
    temporaryPassword: currentPassword,
    password: newPassword,
  };

  const submit = async (e) => {
    e.preventDefault();

    if (passwordValid.test(newPassword)) {
      if (newPassword === renterPassword) {
        await axios.put(`auth/savepassword/${id}`, newPassword_data, options);
        dispatch(loginReducer.Logout());
        dispatch(loginReducer.Temp_password(0));
        dispatch(AccessTockenReducer.accessTocken(""));
        dispatch(AccessTockenReducer.refreshTocken(""));
      } else {
        alert("Please check the entered password!");
        return false;
      }
    } else {
      alert(
        "The Password should have atleast 1 letter, 1 number and 1 special character!"
      );
      return false;
    }
  };

  return (
    <div className="container-fluid g-0 m-0 p-0" style={{ overflow: "hidden" }}>
      <div className="row ">
        <div
          className="col-lg-6 col-md-6  text-center col-sm-12"
          style={{ marginTop: "150px", marginBottom: "75px" }}
        >
          <form onSubmit={submit}>
            <h2>
              <strong>Update Password!</strong>
            </h2>
            <Box
              component="form"
              sx={{
                "& > :not(style)": { m: 1, width: "36ch" },
              }}
              noValidate
              autoComplete="off"
            >
              <TextField
                label="Current Password"
                variant="outlined"
                minLength="8"
                maxLength="20"
                value={currentPassword}
                onChange={(e) => {
                  const { value } = e.target;
                  setCurrentPassword(value);
                }}
                type={showCurrentPassword ? "text" : "password"} // <-- This is where the magic happens
                // onChange={someChangeHandler}
                InputProps={{
                  // <-- This is where the toggle button is added.
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() =>
                          setShowCurrentPassword(!showCurrentPassword)
                        }
                        onMouseDown={() =>
                          setShowCurrentPassword(!showCurrentPassword)
                        }
                      >
                        {showCurrentPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <br />
              <TextField
                label="New Password"
                variant="outlined"
                minLength="8"
                maxLength="20"
                value={newPassword}
                onChange={(e) => {
                  const { value } = e.target;
                  setNewPassword(value);
                }}
                type={showNewPassword ? "text" : "password"} // <-- This is where the magic happens
                // onChange={someChangeHandler}
                InputProps={{
                  // <-- This is where the toggle button is added.
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowNewPassword(!showNewPassword)}
                        onMouseDown={() => setShowNewPassword(!showNewPassword)}
                      >
                        {showNewPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <br />
              <TextField
                label="Re-Enter Password"
                variant="outlined"
                minLength="8"
                maxLength="20"
                value={renterPassword}
                onChange={(e) => {
                  const { value } = e.target;
                  setReEnterPassword(value);
                }}
                type={showReenterPassword ? "text" : "password"} // <-- This is where the magic happens
                // onChange={someChangeHandler}
                InputProps={{
                  // <-- This is where the toggle button is added.
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() =>
                          setShowReenterPassword(!showReenterPassword)
                        }
                        onMouseDown={() =>
                          setShowReenterPassword(!showReenterPassword)
                        }
                      >
                        {showReenterPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <button className="btn1" type="submit">
              Update Password
            </button>
            <br></br>
          </form>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <img
            className="Logo"
            width="100%"
            height="100%"
            src={require("../../images/desktop_img.png")}
            alt="TATA Elxsi"
          ></img>
        </div>
      </div>
    </div>
  );
}
export default UpdatePassword;
